import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { getPermissionHomePath } from "../../helpers/getPermissionHomePath";

export default function RoleHomeRedirect() {
  const { permissions } = useAuth();
  return <Navigate to={getPermissionHomePath(permissions)} replace />;
}
